var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemaleIconBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 60,
    viewBox: "0 0 24 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_115_4186)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60767 46.4934V60",
    stroke: "#FBC809",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3923 46.4934V60",
    stroke: "#FBC809",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42847 44.5895C3.42847 44.5895 7.42633 17.0327 12.3581 17.0327C17.2899 17.0327 21.2877 44.5895 21.2877 44.5895H3.42847Z",
    stroke: "#D31421",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0847 15.0835C19.895 12.3067 19.895 7.80464 17.0847 5.02786C14.2744 2.25107 9.71807 2.25107 6.90779 5.02786C4.09751 7.80464 4.09751 12.3067 6.90779 15.0835C9.71807 17.8603 14.2744 17.8603 17.0847 15.0835Z",
    stroke: "#D31421",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_4186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIconBw);
export default __webpack_public_path__ + "static/media/FemaleIconBW.593d7080dc6d4c0615ac4f9ffb39347f.svg";
export { ForwardRef as ReactComponent };